/** Ambient animated backdrop in the Phidio brand colours. */
export function Aurora() {
  return (
    <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-ink-950">
      <div className="absolute -top-1/3 left-1/2 h-[70vmax] w-[70vmax] -translate-x-1/2 rounded-full bg-[radial-gradient(circle_at_center,var(--color-phidio-500)_0%,transparent_62%)] opacity-30 blur-3xl animate-aurora" />
      <div className="absolute -bottom-1/3 -left-1/4 h-[55vmax] w-[55vmax] rounded-full bg-[radial-gradient(circle_at_center,#7c3aed_0%,transparent_65%)] opacity-25 blur-3xl animate-aurora [animation-delay:-6s]" />
      <div className="absolute -right-1/4 top-1/4 h-[50vmax] w-[50vmax] rounded-full bg-[radial-gradient(circle_at_center,var(--color-phidio-600)_0%,transparent_65%)] opacity-20 blur-3xl animate-aurora [animation-delay:-12s]" />
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            'linear-gradient(to right, white 1px, transparent 1px), linear-gradient(to bottom, white 1px, transparent 1px)',
          backgroundSize: '64px 64px',
          maskImage: 'radial-gradient(ellipse at center, black 20%, transparent 72%)',
        }}
      />
    </div>
  );
}
